/**
 * Dayjs configuration — the only place dayjs is imported and configured.
 * All date handling in `@pandas/core` (and every consumer) goes through
 * `./utils`; never import `dayjs` or call `new Date()`/`Date.now()` elsewhere.
 */

import dayjs from "dayjs";
// Explicit `.js` extensions on every deep dayjs subpath: dayjs's package.json has no "exports" map, so bare specifiers resolve fine under bundlers but fail strict Node ESM resolution (Playwright's test loader), throwing `ERR_MODULE_NOT_FOUND`.
import advancedFormat from "dayjs/plugin/advancedFormat.js";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";
import "dayjs/locale/el.js";
import "dayjs/locale/en.js";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

/** Supported date-format locales for the compiled product-v2 language catalog. */
export type DateLocale = "en" | "el";

/** Set the active dayjs locale. */
export function setDateLocale(locale: DateLocale): void {
	dayjs.locale(locale);
}

export { dayjs };
